import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from '../../headersService'


export const fetchTopReports = createAsyncThunk('fetchTopReports', async (obj, { rejectWithValue }) => {
    try {
        const { data } = await axiosInstance.get(`${process.env.REACT_APP_BACKEND_URL}/api/reports?year=${obj.year}`);
        return data
    } catch (error) {
        console.log(error)
        return rejectWithValue(error)
    }
})

export const getReportsSlice = createSlice({
    name: 'get Reports',
    initialState: {
        loading: false,
        report: null,
        error: null
    },
    extraReducers: (builder) => {
        builder.addCase(fetchTopReports.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(fetchTopReports.fulfilled, (state, action) => {
            state.loading = false;
            state.report = action.payload
        })
        builder.addCase(fetchTopReports.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload
        })
    }
})

export default getReportsSlice.reducer